// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__Q1vlO","centered":"LoadingSpinner_centered__FVv6c"};